import { useQuery } from '@apollo/client/react'
import { graphql, type ResultOf, type VariablesOf } from '@tucan/graphql'
import { COMPANY_FRAGMENT } from '../fragment/company.fragment'

const QUERY = graphql(`
  query getCompany($id: ID!) {
    company: getCompanyById(id: $id) {
      ...Company
    }
  }
`, [COMPANY_FRAGMENT])

type Data = ResultOf<typeof QUERY>
type Variables = VariablesOf<typeof QUERY>

export const useCompanyQuery = (
  options: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, options)
